// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"27":"f452bc31","181":"1ea260d0","279":"0a970b1c","319":"4cc82d60","418":"adb4fec1","479":"abdd1c31","583":"47a21576","637":"00791908","880":"8774ad7b","895":"2950f335","903":"2627c174","983":"69124587"}[chunkId] + ".chunk.js";
};